export default {
      id: "settings-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#settings",
      toString: function () {
        return this.url;
      }
    }